module.exports = __webpack_public_path__ + "assets/img/Edito_Olivier-Lecler_menu.b152793c-ps.jpg";